"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgComponent(props, svgRef) {
  return (0, _jsxRuntime.jsx)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), {}, {
    children: (0, _jsxRuntime.jsx)("path", {
      d: "M6.5 7.429H8c.331 0 .6-.256.6-.572 0-.315-.269-.571-.6-.571h-.6V6c0-.316-.269-.571-.6-.571-.331 0-.6.255-.6.571v.314c-.755.146-1.271.814-1.194 1.544.078.73.723 1.286 1.494 1.285h.6c.166 0 .3.128.3.286a.293.293 0 01-.3.285H5.6c-.331 0-.6.256-.6.572 0 .315.269.571.6.571h.6v.286c0 .315.269.571.6.571.331 0 .6-.256.6-.571v-.314c.755-.146 1.271-.814 1.194-1.544C8.516 8.555 7.87 7.999 7.1 8h-.6a.293.293 0 01-.3-.286c0-.158.134-.285.3-.285zm6.9.857h-1.8V3.143a.567.567 0 00-.3-.497.626.626 0 00-.6 0l-1.8.983-1.8-.983a.626.626 0 00-.6 0l-1.8.983-1.8-.983a.626.626 0 00-.6 0 .567.567 0 00-.3.497v9.143C2 13.232 2.806 14 3.8 14h8.4c.994 0 1.8-.768 1.8-1.714V8.857c0-.315-.269-.571-.6-.571zm-9.6 4.571c-.331 0-.6-.256-.6-.571V4.13l1.2.652a.677.677 0 00.6 0L6.8 3.8l1.8.983a.677.677 0 00.6 0l1.2-.652v8.155c.002.195.038.388.108.571H3.8zm9-.571c0 .315-.269.571-.6.571-.331 0-.6-.256-.6-.571V9.429h1.2v2.857z",
      fill: "currentColor",
      fillRule: "nonzero"
    })
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=Billing.js.map